import { Component, OnInit, Input, Output, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Upload } from '../utils/upload';
import { MatDialog } from '@angular/material/dialog';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import { EventEmitter } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-uploadwidget',
  templateUrl: './uploadwidget.component.html',
  styleUrls: ['./uploadwidget.component.css']
})
export class UploadwidgetComponent implements OnInit {
  model: any;
  selectedFiles: FileList;
  public currentUpload: Upload;

  @Input()
  label: string;
  @Input()
  path: string;
  @Output()
  uploadCompleted = new EventEmitter();
  @Output()
  uploadFailed = new EventEmitter();

  user: any;
  uploads: any;
  uid: string;

  constructor(
    private authService: AuthService,
    public afs: AngularFirestore,
    private dialog: MatDialog,
    @Inject(Router) private _router: Router,
    private storage: AngularFireStorage
  ) {
    this.model = {};
  }

  ngOnInit() {
    this.authService.authState.pipe(first()).subscribe(user => {
      this.uid = user?.uid;
    });
  }

  public uploadFile2(event, f) {
    console.log('upload  filevar ', f, event.target.files.item(0));
    this.selectedFiles = event.target.files;
    const file = this.selectedFiles.item(0);
    if (file.size > 50 * 1024 * 1024) {
      alert('Datei zu groß! Datei muss kleiner als 50MB sein.');
      return;
    }
    this.currentUpload = new Upload(file);
    this.pushUpload(this.currentUpload);
  }

  pushUpload(upload: Upload) {
    const filePath = `${this.path}/${upload.file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = fileRef.put(upload.file);

    task.percentageChanges().subscribe(percentage => {
      if (percentage !== undefined) {
        upload.progress = Math.round(percentage);
      }
    });

    task.then(async (snapshot) => {
      console.log('Upload successful, snapshot:', snapshot);
      const downloadURL = await fileRef.getDownloadURL().toPromise();
      let uploadresult = {
        url: downloadURL,
        name: upload.file.name
      };
      this.uploadCompleted.emit(uploadresult);
      this.currentUpload = undefined;
      this.selectedFiles = undefined;
      this.model = {};
    }).catch(error => {
      console.error('Upload error:', error);
      this.uploadFailed.emit(error);
    });
  }
}
